(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["appstle-member-portal"] && !Shopify.designMode) return;
  try {
    const setupMemberPortalTheme = () => {
    const portalThemeTemplate = document.querySelector('[data-appstle-member-portal-theme]')
    const portalFrame = document.querySelector('#appstle_iframe')

    if (!portalThemeTemplate || !portalFrame) return

    const applyPortalTheme = () => {
      try {
        const portalDocument = portalFrame.contentDocument

        if (!portalDocument?.head) return false
        if (!portalDocument.querySelector('#appstleMembershipRoot')) return false
        if (!portalDocument.querySelector('#talesoft-appstle-member-portal-theme')) {
          portalDocument.head.append(portalThemeTemplate.content.cloneNode(true))
        }

        return true
      } catch (error) {
        return false
      }
    }

    portalFrame.addEventListener('load', applyPortalTheme)

    let attempts = 0
    const themeInterval = window.setInterval(() => {
      attempts += 1

      if (applyPortalTheme() || attempts >= 40) {
        window.clearInterval(themeInterval)
      }
    }, 250)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMemberPortalTheme, { once: true })
  } else {
    setupMemberPortalTheme()
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-preview-scripts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.button = this.querySelector('button');
        this.button.addEventListener('click', () => {
          this.player = this.querySelector('template').content.firstElementChild.cloneNode(true);
          this.player.setAttribute('tabindex', '0');
          if (this.player.tagName === 'IFRAME') this.player.title = this.button.textContent.trim();
          this.button.hidden = true;
          this.append(this.player);
          this.player.focus();
          if (this.player.tagName === 'VIDEO') this.player.play().catch(() => {});
        });
      }

      reset() {
        this.player?.remove();
        this.player = null;
        this.button.hidden = false;
      }
    });
  }

  if (!customElements.get('product-card-preview')) {
    customElements.define('product-card-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.trigger = this.querySelector('.product-card__preview-button');
        this.dialog = this.querySelector('dialog');
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => {
          this.dialog.showModal();
          this.querySelector('.product-media__play')?.click();
        });
        this.querySelector('[data-preview-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.querySelector('deferred-media')?.reset?.();
          this.trigger.focus();
        });
      }

      disconnectedCallback() {
        this.querySelector('deferred-media')?.reset?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["membership-reel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('membership-reel')) {
    customElements.define('membership-reel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const player = this.querySelector('template').content.firstElementChild.cloneNode(true);
          button.hidden = true;
          this.append(player);
          player.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pack-builder"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-pack-builder]').forEach((builder) => {
    const variantsScript = builder.querySelector('[data-variants-json]');

    if (!variantsScript) {
      return;
    }

    const variants = JSON.parse(variantsScript.textContent);
    const variantIdInput = builder.querySelector('[data-variant-id-input]');
    const summary = builder.querySelector('[data-pack-summary]');
    const form = builder.closest('form');
    const productPage = builder.closest('.product-page');
    const price = productPage.querySelector('[data-product-price]');
    const comparePrice = productPage.querySelector('[data-product-compare-price]');
    const submitButton = form.querySelector('[data-product-submit]');
    const submitLabel = submitButton.dataset.availableLabel;
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const unavailableLabel = builder.dataset.unavailableLabel;
    const soldOutLabel = builder.dataset.soldOutLabel;
    const currency = builder.dataset.currencyCode || 'GBP';
    const locale = document.documentElement.lang || 'en-GB';
    const noAudioVariantLabel = builder.dataset.noAudioVariantLabel || 'visual video only (no audio)';
    const freeLabel = builder.dataset.freeLabel;
    const includedPriceLabel = builder.dataset.includedPriceLabel;
    const wasLabel = comparePrice ? comparePrice.dataset.wasLabel || 'Was' : 'Was';

    const formatVariantTitle = (title) => {
      const value = String(title || '');
      const lowered = value.toLowerCase();

      if (lowered.includes('full video only')) {
        return value.replace(/full video only/gi, noAudioVariantLabel);
      }

      if (lowered.includes('video only')) {
        return value.replace(/video only/gi, noAudioVariantLabel);
      }

      return value;
    };

    const moneyFormatter = new Intl.NumberFormat(locale, {style: 'currency', currency});
    const formatMoney = (value) => moneyFormatter.format(value / 100);

    const formatPriceText = (value) => {
      if (includedPriceLabel) return includedPriceLabel;

      if (value === 0) {
        return freeLabel;
      }

      return formatMoney(value);
    };

    const parsePackTitle = (title) => {
      const lowered = title.toLowerCase();
      const parsed = {
        resolution: '',
        pack: '',
        loops: '',
      };

      if (lowered.includes('1080p')) {
        parsed.resolution = '1080p';
      }

      if (lowered.includes('4k')) {
        parsed.resolution = '4K';
      }

      if (lowered.includes('production pack')) {
        parsed.pack = 'Production Pack';
      }

      if (lowered.includes('standard')) {
        parsed.pack = 'Standard';
      }

      if (lowered.includes('loops')) {
        parsed.loops = 'With loops';
      } else {
        parsed.loops = 'Without loops';
      }

      return parsed;
    };

    const readSelections = () => {
      const mode = builder.dataset.builderMode;

      if (mode === 'parsed') {
        const selections = {};

        builder.querySelectorAll('[data-group-key]').forEach((group) => {
          const active = group.querySelector('.pack-builder__option.is-active');

          if (active) {
            selections[group.dataset.groupKey] = active.dataset.optionValue;
          }
        });

        return selections;
      }

      return Array.from(builder.querySelectorAll('[data-group-index]')).map((group) => {
        const active = group.querySelector('.pack-builder__option.is-active');
        return active ? active.dataset.optionValue : '';
      });
    };

    const findMatchingVariant = (selections = readSelections()) => {
      const mode = builder.dataset.builderMode;

      if (mode === 'parsed') {
        return variants.find((variant) => {
          const parsed = parsePackTitle(variant.title);

          if (selections.resolution && parsed.resolution !== selections.resolution) {
            return false;
          }

          if (selections.pack && parsed.pack !== selections.pack) {
            return false;
          }

          if (selections.loops && parsed.loops !== selections.loops) {
            return false;
          }

          return true;
        });
      }

      return variants.find((variant) => {
        return variant.options.every((optionValue, index) => {
          return selections[index] === optionValue;
        });
      });
    };

    const readSelectionsForButton = (button) => {
      const mode = builder.dataset.builderMode;
      const group = button.closest('[data-group-index], [data-group-key]');

      if (!group) {
        return readSelections();
      }

      if (mode === 'parsed') {
        return {
          ...readSelections(),
          [group.dataset.groupKey]: button.dataset.optionValue,
        };
      }

      const selections = readSelections();
      selections[Number(group.dataset.groupIndex)] = button.dataset.optionValue;
      return selections;
    };

    const updateOptionPrices = () => {
      builder.querySelectorAll('[data-price-options] .pack-builder__option').forEach((button) => {
        const candidate = findMatchingVariant(readSelectionsForButton(button));
        const optionPrice = button.querySelector('[data-option-price]');

        if (optionPrice) {
          optionPrice.textContent = candidate ? formatPriceText(candidate.price) : '';
        }
      });
    };

    const setActive = (button) => {
      const group = button.closest('[data-group-index], [data-group-key]');

      if (!group) {
        return;
      }

      group.querySelectorAll('.pack-builder__option').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    };

    const syncVariant = () => {
      const variant = findMatchingVariant();

      const available = Boolean(variant?.available);
      variantIdInput.value = available ? variant.id : '';
      submitButton.disabled = !available;
      submitButton.textContent = available ? submitLabel : (variant ? soldOutLabel : unavailableLabel);
      if (dynamicCheckout) {
        dynamicCheckout.hidden = !available;
        dynamicCheckout.inert = !available;
      }
      updateOptionPrices();

      if (!variant) {
        if (summary) summary.textContent = unavailableLabel;
        if (price) price.textContent = unavailableLabel;
        if (comparePrice) comparePrice.hidden = true;
        const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
        return;
      }

      if (summary) {
        summary.textContent = formatVariantTitle(variant.title);
      }

      if (price) {
        price.textContent = formatPriceText(variant.price);
      }

      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.hidden = false;
          comparePrice.textContent = `${wasLabel} ${formatMoney(variant.compare_at_price)}`;
        } else {
          comparePrice.hidden = true;
          comparePrice.textContent = '';
        }
      }


      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    builder.querySelectorAll('.pack-builder__option').forEach((button) => {
      button.addEventListener('click', () => {
        setActive(button);
        syncVariant();
      });
    });

    form.addEventListener('submit', (event) => {
      if (!findMatchingVariant()?.available) event.preventDefault();
    });
    syncVariant();
  });
  } catch(e) { console.error(e); }
})();

})();
